export const ANDROID = 'ANDROID';
export const IOS = 'IOS';
export const MOBILE_OS = 'MOBILE_OS';
export const NOT_MOBILE = 'NOT_MOBILE';
export const IAMSCHOOL_AOS_APP_DOWNLOAD_URL = 'https://play.google.com/store/apps/details?id=com.imcompany.school2';
export const IAMSCHOOL_IOS_APP_DOWNLOAD_URL = 'https://itunes.apple.com/kr/app/id540665717';

if (!window.navigator) {
    // 서버는 navigator 없으므로 폴리필
    window.navigator = {userAgent: ''};
}

const isMobile = (/iphone|ipad|ipod|android/i.test(window.navigator.userAgent.toLowerCase()));

export const checkUserAgent = () => {
    if (isMobile) {
        const userAgent = window.navigator.userAgent.toLowerCase();
        if (userAgent.search('android') > -1) {
            return ANDROID;
        } else if ((userAgent.search('iphone') > -1) || (userAgent.search('ipod') > -1) || (userAgent.search('ipad') > -1)) {
            return IOS;
        } else {
            return MOBILE_OS;
        }
    } else {
        return NOT_MOBILE;
    }
};

export const dichotomyMobileOrNot = () => {
    const userAgent = checkUserAgent();
    return userAgent !== NOT_MOBILE;
};

export const dichotomyAndroidOrNot = () => {
    const userAgent = checkUserAgent();
    return userAgent !== IOS;
};
